import { getIbsAccountInfo, checkIfAnalyst } from '../Services/IBS/IbsService';
import { PATH_SURVEY_TYPE_MAP, PABS_SURVEY_MAP, SURVEY_PAGE_SLUGS, SurveyTypeURL } from '../Enums/constants';

const firstSegment = (path) => (path ?? "").split('/').filter(Boolean)[0];

const PABS_SERVICES = Object.entries(SurveyTypeURL)
    .filter(([type]) => type.startsWith("PABS"))
    .map(([, url]) => firstSegment(url));

const IBS_SERVICES = Object.entries(SurveyTypeURL)
    .filter(([type]) => !type.startsWith("PABS"))
    .map(([, url]) => firstSegment(url));

export async function navigateToSurvey() {
    const redirectUri = localStorage.getItem("redirectUri") ?? "";
    const segments = redirectUri.split('/').filter(Boolean);
    const service = segments[0] ?? "";
    const page = (segments[1] ?? "").toLowerCase();
    const hasDeepLink = (SURVEY_PAGE_SLUGS[service] ?? []).includes(page);

    if (IBS_SERVICES.includes(service)) {
        await getIbsAccountInfo();

        if (hasDeepLink) {
            window.location.replace(redirectUri);
            return;
        }
        
        const defaultProductString = "ibs";
        const productString = (localStorage.getItem("lastOpenedProductType") ?? defaultProductString).toLowerCase();

        const targetPath = checkIfAnalyst() ? "/laundromat" : "/home";
        window.location.replace(`/${productString}${targetPath}`);
    } else if (PABS_SERVICES.includes(service)) {

        if (hasDeepLink) {
            window.location.replace(redirectUri);
            return;
        }

        const lastSurveyTypeId = Number(localStorage.getItem("lastOpenedSurveyTypeIdCache"));
        // Find the corresponding survey type from PABS_SURVEY_MAP
        const survey = PABS_SURVEY_MAP[lastSurveyTypeId];

        if (survey?.redirect) {
            window.location.replace(survey.redirect);
        } else {
            window.location.replace(PATH_SURVEY_TYPE_MAP["/pabs"]);
        }
    }
}
